import type { SVGProps } from 'react'

export const LinkedInIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" {...props} viewBox="0 0 24 24">
    <rect width="24" height="24" rx="4" fill="#0A66C2" />
    <path
      fill="#fff"
      d="M7.2 9.1H4.3v9.6h2.9zM5.75 4.5a1.68 1.68 0 1 0 0 3.36 1.68 1.68 0 0 0 0-3.36M18.7 18.7h-2.9v-4.66c0-1.11-.02-2.54-1.55-2.54-1.55 0-1.79 1.21-1.79 2.46v4.74H9.56V9.1h2.79v1.31h.04c.39-.74 1.34-1.51 2.76-1.51 2.95 0 3.5 1.94 3.5 4.47z"
    />
  </svg>
)
